import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ReportCommonService } from '../shared/services/report-common.service';

@Component({
  selector: 'delete-filter-template',
  templateUrl: './delete.component.html',
  styleUrls: ['./filtersdialog.component.scss']
})
export class DeleteComponent {

  constructor(
    public commonData: ReportCommonService
    ){}

  @ViewChild('popupModal') public modal: any;
  @Input() public dialogOpened: boolean = false;
  @Input() public templateName: string = '';
  @Output() public deleted = new EventEmitter();
  @Output() public canceled = new EventEmitter();
  @Output() public dialogOpenedChange = new EventEmitter();
  @Output() public templateNameChange = new EventEmitter();

  public clickContinue(){
    this.deleted.emit();
    this.dialogOpened = false;
  }

  public clickCancel(){  
    this.canceled.emit();
    this.dialogOpened = false;
  }

  public close(){
    this.canceled.emit();
    this.dialogOpened = false;
  }

  public open() {
    this.dialogOpened = true;
  }
}
